<script>import { melt } from "@melt-ui/svelte";
import { getCtx } from "../ctx.js";
const {
  elements: { input },
  options: { value }
} = getCtx();
</script>

<input {...$input} use:$input.action value={$value ?? "on"} {...$$restProps} />
